module.exports = __webpack_public_path__ + "media/images/lp_v6_img16-48124de8d893957cb215f2e60605e25d.webp";